import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['serviceType'])}` : '';
  const getTaxExemptionReport = `getTaxExemptionReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getTaxExemptionReport} {
        id
        accountId
        firstName
        lastName
        startDate
        endDate
        taxType
        productCode
        certificateNumber
        lowerLimit
        upperLimit
        fileName
        exemptionPercentage
        serviceType
      }
    }
  `;
};
